export const OccupationFactory = () => {
    return function Occupation() {

        this.name = null;
        this.id = null;
        this.ocuCode = null;
        this.refNum = null;
    };
};
